"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const Breadcrumbs = props => {
    const { path, isHidden, data = [] } = props;
    if (isHidden) {
        return null;
    }
    const mappedPath = (0, react_1.useMemo)(() => Array.isArray(path)
        ? path.map(item => ({ path: item, title: item }))
        : Object.keys(path).map(key => ({
            path: path[key],
            title: key,
        })), [path]);
    return ((0, jsx_runtime_1.jsx)(material_1.Breadcrumbs, { "aria-label": "breadcrumbs", children: mappedPath.map(({ path, title }, i) => {
            if (i === mappedPath.length - 1) {
                return ((0, jsx_runtime_1.jsx)(material_1.Typography, { color: "textPrimary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `pages.${title}.title`, values: data[i] }) }, i));
            }
            return ((0, jsx_runtime_1.jsx)(material_1.Link, { color: "inherit", component: react_router_dom_1.Link, to: `/${path}`, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `pages.${title}.title`, values: data[i] }) }, i));
        }) }));
};
exports.Breadcrumbs = Breadcrumbs;
//# sourceMappingURL=index.js.map